import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"

/**
 * Where Kite sends the browser after login (the one redirect URL registered in the Kite console).
 * The phone app starts the flow with client=mobile (carried back via redirect_params), so we bounce
 * to its paisa://zerodha deep link; the web app's own flow is forwarded to the settings callback.
 */
export function relayTarget(search: string): string {
  const params = new URLSearchParams(search)
  const out = new URLSearchParams()
  for (const k of ["request_token", "status", "owner"]) {
    const v = params.get(k)
    if (v) out.set(k, v)
  }
  const qs = out.toString()
  if (params.get("client") === "mobile") return `paisa://zerodha?${qs}`
  return `/settings?tab=integrations&callback=zerodha${qs ? `&${qs}` : ""}`
}

export const Route = createFileRoute("/zerodha-return")({
  component: ZerodhaReturn,
})

function ZerodhaReturn() {
  useEffect(() => {
    window.location.replace(relayTarget(window.location.search))
  }, [])
  return (
    <p className="flex min-h-dvh items-center justify-center bg-bg-base text-body text-text-secondary">
      Returning to Paisa…
    </p>
  )
}
